export default __webpack_public_path__ + "static/media/img-11.ff4f4770.jpg";